import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { inviteUserAPI } from './api';

const ALL_USERS = 'allUsers';

export function useInviteUser({ onSuccess } = {}) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const { mutate, isLoading, isSuccess, isError } = useMutation(
    (userData) => inviteUserAPI(userData),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ALL_USERS, tenantId]);
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'success',
            description: 'inviteUserSuccess',
          },
        });
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'inviteUserError',
          },
        });
      },
    },
  );

  return {
    inviteUser: mutate,
    isLoading,
    isSuccess,
    isError,
  };
}
